import React from 'react';
import { PRICE, PRICE_PLN } from '../data/valueStack';
export function PromoBar() {
  return <div className="border-b border-night-600 bg-night-950" data-id="element-287" data-mp="88vt6pra98uk">
      <div className="mx-auto flex max-w-shell items-center justify-center px-5 py-2.5 sm:px-6" data-id="element-288" data-mp="8bi8xcobuunv">
        <p className="min-w-0 truncate text-center text-[11px] text-cream sm:text-sm" data-id="element-289" data-mp="3gm57f9qaiux">
          <span className="mr-1.5 font-bold uppercase tracking-wider text-amber" data-id="element-290" data-mp="3uoqa6ixyvpqk">Cena premierowa</span>
          <span className="hidden sm:inline" data-id="element-291" data-mp="3qopt0qjhh0ft">Pakiet 6 tomów + 6 darmowych bonusów — </span>
          tylko {PRICE} ({PRICE_PLN}) · płatność jednorazowa
        </p>
      </div>
    </div>;
}